import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "gatsby"
import PropTypes from "prop-types";
import '../styles/style.scss';


class FooterSection extends Component {
    render() {
      const { withMargin, withPadding } = this.props;
      var footerClass = "footer";
      if (withMargin) footerClass += " with-margin";
      if (withPadding) footerClass += " with-padding";
      return(
        <Container className={footerClass}>
          <Row>
            <Col>
              <p className="heading"><Link to="/">Home</Link></p>
              <p><Link to="/#why-choose-bld-ai">Why choose bld.ai</Link></p>
              <p><Link to="/#testimonials">What our clients are saying</Link></p>
            </Col>
            <Col>
              <p className="heading"><Link to="/process/">Process</Link></p>
              <p><Link to="/process/#assess-the-opportunity">Assess the opportunity</Link></p>
              <p><Link to="/process/#identify-data">Identify the relevant data</Link></p>
              <p><Link to="/process/#walk-the-shop-floor">Walk the shop floor</Link></p>
              <p><Link to="/process/#do-the-math">Do the math</Link></p>
              <p><Link to="/process/#build-and-integrate">Build your product</Link></p>
              <p><Link to="/process/#drive-adoption">Drive adoption</Link></p>
              <p><Link to="/process/#secure-your-investment">Secure your investment</Link></p>
              <p><Link to="/process/#deploy-and-sustain">Deploy, maintain and improve </Link></p>
            </Col>
            <Col>
              <p className="heading"><Link to="/tools/">Tools</Link></p>
              <p><Link to="/tools/#data-science-tools">Data science</Link></p>
              <p><Link to="/tools/#data-engineering">Data engineering</Link></p>
              <p><Link to="/tools/#design">Design</Link></p>
              <p><Link to="/tools/#devops">DevOps</Link></p>
              <p><Link to="/tools/#development">Development</Link></p>
              <p><Link to="/tools/#security">Security</Link></p>
              <p><Link to="/tools/#quality-assurance">Quality assurance</Link></p>
              <p><Link to="/tools/#support-and-maintenance">Support and maintenance</Link></p>
            </Col>
            <Col>
              <p className="heading"><Link to="/solutions/">Solutions</Link></p>
              <p><Link to="/solutions/#autonomous-pricing">Autonomous pricing</Link></p>
              <p><Link to="/solutions/#mobile-asset-optimization">Mobile asset optimization</Link></p>
              <p><Link to="/solutions/#asset-management">Asset management</Link></p>
              <p><Link to="/solutions/#automating-operations">Automating operations</Link></p>
              <p><Link to="/solutions/#customer-behavior-sim">Customer behavior simulation</Link></p>
              <p><Link to="/solutions/#predictive-maintenance">Preventive maintenance</Link></p>
              <p><Link to="/solutions/#injury-prediction">Injury prediction</Link></p>
              <p><Link to="/solutions/#demand-forecasting">Demand forecasting</Link></p>
              <p><Link to="/solutions/#anomaly-detection">Supply chain anomaly detection</Link></p>
              <p><Link to="/solutions/#data-accuracy">Data accuracy</Link></p>
            </Col>
            <Col>
              <p className="heading"><Link to="/about/">About</Link></p>
              <p><Link to="/about/#our-philosophy">Philosophy</Link></p>
              <p><Link to="/about/#values-section">Values</Link></p>
            </Col>
            <Col>
              <p className="heading"><Link to="/news/">News</Link></p>
              <p><Link to="/news/#news-organizations">News organizations</Link></p>
              <p><Link to="/news/#news-industry">Industry</Link></p>
              <p><Link to="/news/#news-academia">Academia</Link></p>
              <p><Link to="/news/#news-consulting">Consulting</Link></p>
            </Col>
            <Col>
              <p className="heading"><Link to="/contact/">Contact Us</Link></p>
              <p><Link to="/contact/#contact-us">Sales</Link></p>
              <p><Link to="/contact/#contact-us">Partnerships</Link></p>
              <p><Link to="/contact/#contact-us">Careers</Link></p>
            </Col>
          </Row>
        </Container>
      );
    }
}

FooterSection.propTypes = {
  withMargin: PropTypes.bool,
  withPadding: PropTypes.bool,
};

FooterSection.defaultProps = {
  withMargin: true,
  withPadding: true,
};

export default (FooterSection);